import React from 'react'
import tenHairColorBanner from "./../../../../../Images/Blog/ten_hair_colors_for_all_ages/Banner.png";

const TenHairColorAllAgesImg = () => {
  return (
    <div className="blogImg-content">
      <img src={tenHairColorBanner} alt="Ten Hair Color Banner" loading="lazy" />
    </div>
  )
}

export default TenHairColorAllAgesImg
